export default {
  name: 'RequestAnimationFrame',
  props: {
    transform: {
      type: Function,
      default: (arg) => arg
    }
  },
  data () {
    return {
      _id: null,
      current: Date.now()
    }
  },
  methods: {
    tick () {
      const currentValue = this.transform(this.current)
      this.current = Date.now()
      const nextValue = this.transform(this.current)
      if (currentValue !== nextValue) {
        this.$emit('tick', nextValue)
      }
      this._id = requestAnimationFrame(this.tick)
    }
  },
  created () {
    this.tick = this.tick.bind(this)
  },
  mounted () {
    requestAnimationFrame(this.tick)
  },
  beforeDestroy () {
    cancelAnimationFrame(this._id)
  },
  render () {
    return this.$createElement('link')
  }
}



// WEBPACK FOOTER //
// ./src/components/CountTime.js